import { ScenarioTransferType } from '@/shared/api/types';

import { ScenarioFormData } from './types/form';

export const isFirstStep = (step: number) => step === 1;
export const isLastStep = (step: number) => step === 5;

export const isScenarioFormDataFull = (
  scenario: ScenarioFormData,
): scenario is Required<ScenarioFormData> =>
  Boolean(scenario.step1 && scenario.step2 && scenario.step3 && scenario.step4);

export const isOneByOneScenario = (transferType: ScenarioTransferType) =>
  transferType === ScenarioTransferType.OneByOne;

export const isAllAtOnceScenario = (transferType: ScenarioTransferType) =>
  transferType === ScenarioTransferType.AllAtOnce;
